function EmptyComponent() {
  return <div>No beneficial owners to display</div>;
}

export default EmptyComponent;
